/** sessionStorage keys for the admin panel session. Shared so refresh handling and session load/save stay in sync. */
export const ADMIN_ACCESS_TOKEN_KEY = 'nomiss_admin_access_token';
export const ADMIN_REFRESH_TOKEN_KEY = 'nomiss_admin_refresh_token';
